export const getYouthTableData = (state) => state.youth?.youthTableData;
export const getYouthData = (state) => state.youth?.youth;
